<form [formGroup]="form">
   <mat-form-field>
      <mat-label>{{ label }}</mat-label>
      <mat-select
         formControlName="tasks"
         [multiple]="true"
         [compareWith]="compareById"
         (selectionChange)="tasksUpdated($event)"
      >
         <mat-option>
            <ngx-mat-select-search
               placeholderLabel="Search"
               [formControl]="getControl('filter')"
               noEntriesFoundLabel="No tasks found"
            ></ngx-mat-select-search>
         </mat-option>
         <!-- <mat-option *ngFor="let task of filteredTasks$ | async" [value]="task">
            {{ task.name }}
         </mat-option> -->
         <ng-container *ngIf="(priorityTasks$ | async).length > 0">
            <mat-optgroup
               [label]="priorityTasksLabel"
               *ngIf="(filteredPriorityTasks$ | async).length > 0"
            >
               <mat-option *ngFor="let task of filteredPriorityTasks$ | async" [value]="task">
                  {{ task.name }}
               </mat-option>
            </mat-optgroup>
            <mat-optgroup label="All Tasks">
               <mat-option *ngFor="let task of filteredTasks$ | async" [value]="task">
                  {{ task.name }}
               </mat-option>
            </mat-optgroup>
         </ng-container>
         <ng-container *ngIf="(priorityTasks$ | async).length === 0">
            <mat-option *ngFor="let task of filteredTasks$ | async" [value]="task">
               {{ task.name }}
            </mat-option>
         </ng-container>
      </mat-select>
   </mat-form-field>
</form>

